"use strict";

define('rs/form/formpdf/formpdf.view',['rs/form/form.view', 'rs/form/formobjects/radio/radio.formobject'], function (FormView, RadioFormObject) {
  var FormPDFView = FormView.extend({
    templates: {
      'form.pdf.init': 'renderPDFInitFragment'
    },
    setupPageOverflow: function setupPageOverflow() {},
    teardownPageOverflow: function teardownPageOverflow() {},
    renderInitFragment: function renderInitFragment() {
      return this.renderPDFInitFragment.apply(this, arguments);
    },
    setupPDFElement: function setupPDFElement() {
      var element = this.$el,
        formObjects = this.getDelegate().getFormObjectArray(),
        imageQueue = [],
        fo = null,
        foElement = null;
      element.find('.form-object-content-controls').css('width', 'auto');
      var pageWidth = 720;
      element.closest('.pdf-body').css({
        padding: 0,
        width: pageWidth
      });
      element.find('.pdf-form-container').css({
        width: pageWidth
      });
      for (var f = 0, len = formObjects.length; f < len; f++) {
        fo = formObjects[f];
        foElement = fo.getView().$el;
        if (!fo.getView().rendered) {
          continue;
        }
        var maxWidth = pageWidth - fo.getDepthIndex() * 40;
        foElement.css({
          overflow: 'hidden',
          width: maxWidth
        });
        if (fo.type == 'radio' && fo.value) {
          var radioBtn = $(foElement.find('input')[0]);
          radioBtn.parent().addClass('check-mark-content').html('&#10004;');
        } else if (fo.type == 'checkbox' && fo.value) {
          var checkbox = $(foElement.find('input')[0]);
          checkbox.parent().addClass('check-mark-content').html('&#10004;');
        } else if (fo.type == 'textbox' || fo.type == 'datepicker') {
          var div = $('<div></div'),
            txtbox = null;
          if (fo.type == 'textbox') {
            txtbox = $(foElement.find('textarea')[0]);
          } else {
            txtbox = $(foElement.find('input')[0]);
          }
          div.html(fo.getValue());
          txtbox.parent().append(div);
          txtbox.remove();
        } else if (fo.type == 'personfinder' || fo.type == 'sponsorfinder') {
          fo.getView().refreshFormValueForPDF(foElement);
        } else if (fo.type == 'textarea') {
          foElement.find('> .form-object-contents textarea').remove();
          foElement.find('> .form-object-contents img').each(function (index, image) {
            var promise = app.request('imageDimensions', image),
              $image = $(image);
            $image.before('<br/>');
            $(image).parent().css({
              'page-break-inside': 'avoid',
              'display': 'block'
            });
            imageQueue.push(new Promise(function (resolve, reject) {
              (function (p, i, max) {
                p.tap(function (dimensions) {
                  if (dimensions.width > max) {
                    $(i).css({
                      width: max,
                      height: 'auto'
                    });
                  }
                  resolve();
                });
              })(promise, image, maxWidth);
            }));
          });
        }
      }
      element.find('.comment-container').remove();
      element.find('.helptext-button').remove();
      element.find('input').attr('readonly', 'readonly');
      return Promise.all(imageQueue);
    }
  });
  return FormPDFView;
});

